export class ServiceResponse {
  operationResult: boolean = false;
  errorMsg?: string;
  errorCode?: number;

  constructor(init?: Partial<ServiceResponse>) {
    Object.assign(this, init);
  }

  // Getters & Setters
  getOperationResult(): boolean {
    return this.operationResult;
  }
  setOperationResult(value: boolean): void {
    this.operationResult = value;
  }

  getErrorMsg(): string | undefined {
    return this.errorMsg;
  }
  setErrorMsg(value: string | undefined): void {
    this.errorMsg = value;
  }

  getErrorCode(): number | undefined {
    return this.errorCode;
  }
  setErrorCode(value: number | undefined): void {
    this.errorCode = value;
  }
}
